export interface ApiSuccess<T> {
  ok: true;
  message: string;
  data: T;
}

export interface ApiFailure {
  ok: false;
  message: string;
  error: { code: string; message: string; details?: unknown };
}

export type ApiResponse<T> = ApiSuccess<T> | ApiFailure;

const defaultApiBase = import.meta.env.PROD
  ? "https://uinus-form.com/calwalk-api/api"
  : "/api";

export const API_BASE = (import.meta.env.VITE_API_BASE_URL || defaultApiBase).replace(/\/$/, "");

export async function requestApi<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    credentials: "include",
    headers: { "Content-Type": "application/json", "X-CalWalk-Request": "web", ...init?.headers }
  });
  const payload = (await response.json().catch(() => ({
    ok: false,
    message: "서버 응답을 확인할 수 없습니다.",
    error: { code: "INVALID_RESPONSE", message: "서버 응답을 확인할 수 없습니다." }
  }))) as ApiResponse<T>;
  if (!response.ok || !payload.ok) throw new Error(payload.message || "요청을 처리할 수 없습니다.");
  return payload.data;
}
